
export { GoogleMapsServicesProvider } from "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/packages/search-components/filters-library/src/components/autocomplete/provider/GoogleMapsProvider.tsx"